import { useStore, useStoreUI } from '@assets/model/Store';
import { animated, useSpring } from '@react-spring/web';
import { observer } from 'mobx-react';
import { useState } from 'react';
import Lottie from 'react-lottie';
import { Logo } from '../Header/Logo';
import { Flex } from '../UI/Flex/Flex';
import animData from './loading.json';
export const Loading = observer(() => {
    const store = useStore();
    const uiStore = useStoreUI();
    const [showLoading, setShowLoading] = useState(true);
    const targetAlpha = (store.isLoaded || uiStore.disableLoading) && !uiStore.forceLoading ? 0 : 1;
    
    const props = useSpring({
        from: { opacity: 1 },
        to: { opacity: targetAlpha },
        delay: targetAlpha === 1 ? 0 : 1000, // No delay when showing, delay when hiding
        onChange: val => {
            if (val.value['opacity'] == 0) {
                setShowLoading(false);
            }
        }
    });
    
    // Reset showLoading when we need to show loading again
    if (targetAlpha === 1 && !showLoading) {
        setShowLoading(true);
    }

    if (!showLoading) {
        return null;
    }
    const defaultOptions = {
        loop: true,
        autoplay: true,
        play: true,
        animationData: animData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <animated.div
            style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                zIndex: 80000,
                ...props
            }}
        >
            <Flex
                fillCell={true}
                justify="start"
                alignItems="center"
                style={{ backgroundColor: 'white', pointerEvents: 'none' }}
                direction="column"
                className="fade-in"
            >
                <div
                    style={{
                        color: '#243A5C',
                        fontSize: '60px',
                        fontFamily: 'LustTextMedium',
                        marginTop: '200px',
                        zIndex: 100,
                        position: 'relative',
                        top: '50px',
                        animationDelay: '0.2s'
                    }}
                    className="fade-in"
                >
                    <Logo width={300} />
                </div>
                <div className="fade-in" style={{ animationDelay: '0.45s' }}>
                    <Lottie options={defaultOptions} height={400} width={400} />
                </div>
            </Flex>
        </animated.div>
    );
});
